<!--
 * @Description: 查看商机
 * @Author: mdb
 * @Date: 2022-07-01 15:31:13
 * @LastEditTime: 2023-02-17 16:35:46
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <div class="business-status-steps" :class="{ level_5: stepsList.length === 5 }">
        <a-steps :current="statusComputed - 1">
          <a-step
            v-for="item in stepsList"
            :key="item.chanceStatus"
            :status="item.chanceStatus === 6 ? 'process' : ''"
            :title="item.chanceName"
            :description="item.updateTime"
          />
        </a-steps>
      </div>
      <CosViewContent>
        <a-tabs v-model:activeKey="activeTabs" @change="handleTabsChange">
          <a-tab-pane key="info" tab="基本信息">
            <BusinessForm ref="businessFormRef" title="基本信息" type="view" v-model:value="dataForm" :originalStatus="originalStatus"/>
          </a-tab-pane>
          <a-tab-pane key="record" tab="跟进记录">
            <TabsClueCosFollowUp :permissionPage="permissionFollow" appId="cos_fbu" :chanceId="queryId" />
          </a-tab-pane>
          <a-tab-pane key="logs" tab="操作日志">
            <TabsOperationLog appId="cos_fbu" :resourceId="queryId" tableId="FbuBusinessOperationLog" />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
    </dc-layout-content>

    <cos-footer-button :hideOk="true">
      <SellerButton
        v-permission="'fbu_business_edit_btn'"
        :workCode="dataForm.dutyBy"
        controlType="none"
        :loading="loading"
        v-if="dataForm.status<=6"
        @click="handleEdit()"
        >编辑</SellerButton
      >
      <a-button
        v-permission="'fbu_business_write_follow_btn'"
        :loading="loading"
        @click="handleWriteFollowUp()"
        >写跟进</a-button
      >
      <a-popover placement="topRight" trigger="hover" color="#132043e5">
        <template #content>
          <dc-penetrate-content>
            <div class="business-status-popover">
              <a-radio-group v-model:value="status" :disabled="loading" @change="statusChange">
                <a-radio v-for="item in waitingChangeStepList" :key="item.value" :value="item.value">{{
                  item.label
                }}</a-radio>
              </a-radio-group>
            </div>
          </dc-penetrate-content>
        </template>
        <a-button v-permission="'fbu_business_status_btn'" type="primary" :loading="loading">状态变更</a-button>
      </a-popover>
    </cos-footer-button>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { ref, onBeforeMount, computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import BusinessForm from './components/BusinessForm.vue'
import { businessStatusEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import { businessDetails, businessStatusRecord, businessChangeStatus } from '@/api/gucangSales/chanceManage'
import type { FbuBusinessEditParams } from '@/typings/api/chanceManage'
const router = useRouter()
const route = useRoute()
const permissionFollow = {
  edit: 'fbu_business_follow_edit_btn',
  del: 'fbu_business_follow_del_btn',
  comment: 'fbu_business_follow_comment_btn'
}

interface StatusStepItem {
  chanceStatus: number
  updateTime: string
  chanceId?: string
  label?: string
}

const queryId = computed(() => route.query.id as string)
const dataForm = ref<FbuBusinessEditParams>({})
const originalStatus = ref<number>()
const waitingChangeStepList = ref<any[]>([])
const stepsList = ref<any[]>([])
const successStep = { chanceName: businessStatusEnum[3].label, chanceStatus: 5, updateTime: '' }
const failStep = { chanceName: businessStatusEnum[4].label, chanceStatus: 6, updateTime: '' }
const getStatusSteps = () => {
  businessStatusRecord(queryId.value).then((res) => {
    if (!res.data || !res.data.length) return
    // const flag = status.value === 6
    // stepsList.value.splice(3, 1, flag ? failStep : successStep)
    stepsList.value.forEach((item: StatusStepItem) => {
      const find = res.data.find((ele: StatusStepItem) => ele.chanceStatus === item.chanceStatus)
      if (find) item.updateTime = find.updateTime
    })
  })
}
const status = ref<number>(1)
const statusComputed = computed(() => {
  if ([4, 5, 6].includes(status.value)) {
    return status.value - 1
  } else {
    return status.value
  }
})
const getDetails = () => {
  return new Promise((resolve) => {
    businessDetails({ id: route.query.id }).then((res) => {
      originalStatus.value = res.data.status
      status.value = res.data.status
      dataForm.value = res.data
      resolve(res.data)
    })
  })
}
const initFn = async () => {
  await getDetails()
  getStatusSteps()
}
watch(
  () => status.value,
  () => {
    const currentStatus = status.value
    if (!currentStatus) {
      return
    }
    stepsList.value = [
      { chanceName: businessStatusEnum[0].label, chanceStatus: 1, updateTime: '' },
      { chanceName: businessStatusEnum[1].label, chanceStatus: 2, updateTime: '' },
      { chanceName: businessStatusEnum[2].label, chanceStatus: 4, updateTime: '' }
    ]
    if (currentStatus === 6) {
      stepsList.value.push({ chanceName: businessStatusEnum[4].label, chanceStatus: 6, updateTime: '' })
    } else if (currentStatus === 8) {
      stepsList.value.push({ chanceName: businessStatusEnum[6].label, chanceStatus: 8, updateTime: '' })
    } else {
      stepsList.value.push({ chanceName: businessStatusEnum[3].label, chanceStatus: 5, updateTime: '' },
        { chanceName: businessStatusEnum[5].label, chanceStatus: 7, updateTime: '' })
    }

    // if (status === 1) {
    //   waitingChangeStepList.value = businessStatusEnum.filter((item) => item.value === 2 || item.value === 6)
    // } else if (status === 2) {
    //   waitingChangeStepList.value = businessStatusEnum.filter((item) => item.value === 4 || item.value === 6)
    // } else if (status === 4) {
    //   waitingChangeStepList.value = businessStatusEnum.filter((item) => item.value === 6)
    // } else {
    //   waitingChangeStepList.value = []
    // }
    if (currentStatus < 4) {
      waitingChangeStepList.value = businessStatusEnum.filter((item) => item.value === currentStatus + 1 || item.value === currentStatus + 2 || item.value === 6)
    } else if (currentStatus === 4) {
      waitingChangeStepList.value = businessStatusEnum.filter((item) => item.value === 6)
    } else if (currentStatus === 6) {
      /// 未能合作商机，支持可以修改商机状态为【初步接洽】、【确认需求】、【制定方案】
      waitingChangeStepList.value = businessStatusEnum.filter((item) => item.value < 5)
    } else {
      waitingChangeStepList.value = []
    }
  },
  { immediate: true }
)
onBeforeMount(() => {
  initFn()
})

// 跳转编辑页面
const handleEdit = () => {
  router.push({ path: '/fbu/business/edit', query: { id: queryId.value } })
}
// 跳转写跟进页面
const handleWriteFollowUp = () => {
  router.push({
    path: '/fbu/followUpRecord/add',
    query: { followRefId: dataForm.value.saleChanceRefId, chanceId: dataForm.value.id, returnPath: route.fullPath }
  })
}

const businessFormRef = ref()
const loading = ref(false)
const statusChange = (e: any) => {
  loading.value = true
  const params = {
    id: queryId.value,
    status: e.target.value
  }
  businessChangeStatus(params)
    .then(async () => {
      message.success('状态变更成功')
      initFn()
    })
    .catch(() => {
      status.value = dataForm.value.status || 1
    })
    .finally(() => {
      loading.value = false
    })
}

const activeTabs = ref('info')
const handleTabsChange = (val: any) => {
  console.log(val)
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuBusinessView' }
</script>

<style lang="scss" scoped>
.business-status-steps {
  margin-bottom: 20px;
  padding: 0 250px 20px;
  border-bottom: 1px solid #ebebeb;
  &.level_5 {
    padding: 0 210px 20px;
  }
  :deep(.ant-steps-horizontal) {
    .ant-steps-item-title {
      font-size: 14px;
    }
    &:not(.ant-steps-label-vertical) .ant-steps-item-description {
      max-width: 100%;
      font-size: 12px;
    }
  }
}
.ant-tabs {
  overflow: visible;
}
.business-status-popover {
  .ant-radio-group {
    padding: 4px 10px;
    border-radius: 4px;
    background-color: #fff;
  }
  .ant-radio-wrapper {
    color: #111;
  }
}
</style>
